import { useEffect, useRef } from "react"
import { useLocation, useNavigationType } from "react-router-dom"

// Store scroll positions for each path
const scrollPositions = new Map<string, number>()

export function ScrollRestoration() {
  const location = useLocation()
  const navigationType = useNavigationType()
  const prevPathRef = useRef<string>("")

  useEffect(() => {
    // Save current scroll position before navigating away
    const saveScrollPosition = () => {
      if (prevPathRef.current) {
        scrollPositions.set(prevPathRef.current, window.scrollY)
      }
    }

    // On route change
    if (navigationType === "POP") {
      // Back/forward navigation - restore scroll position
      const savedPosition = scrollPositions.get(location.pathname + location.search)
      if (savedPosition !== undefined) {
        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(() => {
          window.scrollTo(0, savedPosition)
        })
      }
    } else {
      // Push navigation (new page) - scroll to top
      saveScrollPosition()
      window.scrollTo(0, 0)
    }

    // Update previous path
    prevPathRef.current = location.pathname + location.search

    // Cleanup: save position when component unmounts or path changes
    return () => {
      scrollPositions.set(location.pathname + location.search, window.scrollY)
    }
  }, [location, navigationType])

  return null
}
